import axios from "axios";

const DEFAULTS = {
    //
}

let instance = axios.create(DEFAULTS)

const updateInstance = (options)=>{
    const newOptions = Object.assign( {}, DEFAULTS, options )
    instance = axios.create( newOptions )
}

const http = ( options = null )=>{
    if(options !== null){
        updateInstance(options)
    }
    return instance
}

export default http